import { Declaration } from 'store/declarations/declaration';
import { FormType } from 'views/declarations/common/DeclarationContext';
import { ics2NonAmendableFields } from 'views/declarations/eu/ics2/nonAmendableFields';

/**
 * Each customs system names its own set of data elements an amendment may not change. A resolver
 * answers that for the declarations it owns; to cover another integration, add one and register it
 * below - nothing in the field components changes.
 *
 * `form` is needed because paths are not unique on their own: the item and house consignment forms
 * run on their own Formik instances, with paths relative to them.
 */
export interface NonAmendableFieldResolver {
    owns: (declaration: Declaration) => boolean;
    isNonAmendable: (declaration: Declaration, form: FormType | undefined, path: string) => boolean;
}

const resolvers: NonAmendableFieldResolver[] = [ics2NonAmendableFields];

export const isNonAmendableField = (
    declaration: Declaration | undefined,
    form: FormType | undefined,
    path: string | undefined
) => {
    if (!declaration || !path) return false;

    return resolvers.some((resolver) => resolver.owns(declaration) && resolver.isNonAmendable(declaration, form, path));
};
